window.select2 = require('select2/dist/js/select2')
require('jquery-ui-bundle/jquery-ui.min')
import SlimSelect from 'slim-select'
import Datepicker from 'vanillajs-datepicker/Datepicker'
import ru from 'vanillajs-datepicker/locales/ru'
import uk from 'vanillajs-datepicker/locales/uk'
// require('inputmask/lib/bindings/inputmask.binding')
// require('inputmask/dist/bindings/inputmask.binding')
window.resetFiles = function (e) {
    e.wrap('<form>').closest('form').get(0).reset()
    e.unwrap()
}

const mobilePhone = '50|63|66|67|68|73|75|77|91|92|93|94|95|96|97|98|99'
const fixPhone = '31|32|33|34|35|36|37|38|39|41|43|44|45|46|47|48|51|52|53|54|55|56|57|61|62|64|65'
const mobilePhoneRegex = new RegExp(`^\\+380(${mobilePhone})[0-9]{7}$`)
const fixPhoneRegex = new RegExp(`^\\+380(${fixPhone})[0-9]{7}$`)
const phoneRegex = new RegExp(`^\\+380(${fixPhone}|${mobilePhone})[0-9]{7}$`)

function disableSubmitButton(button) {
    button.setAttribute('disabled', 'disabled')
    button.classList.add('loading')
}

function enableSubmitButton(button) {
    button.removeAttribute('disabled')
    button.classList.remove('loading')
}

function isTaxID(tin) {
    // Перевірка, чи складається ІПН тільки з цифр
    if (!/^\d{10}$/.test(tin)) {
        return false
    }

    // Calculate check digit
    const digits = tin.split('').map((a) => parseInt(a, 10))

    const multipliers = [-1, 5, 7, 9, 4, 6, 10, 5, 7]
    let checksum = 0
    for (let i = 0; i < multipliers.length; i++) {
        checksum += digits[i] * multipliers[i]
    }

    return checksum % 11 === 10 ? digits[9] === 0 : digits[9] === checksum % 11
}

function setInvalid(element, text) {
    if (element.closest('[class^="col-"]').classList.contains('d-none')) {
        return
    }

    let errorHtml = element.closest('[class^="col-"]').querySelector('.invalid-feedback')

    if (errorHtml) {
        errorHtml.textContent = text ?? ''
    }

    element.classList.remove('is-valid')
    element.classList.add('is-invalid')
}

function setValid(element) {
    if (element.closest('[class^="col-"]').classList.contains('d-none')) {
        return
    }

    let errorHtml = element.closest('[class^="col-"]').querySelector('.invalid-feedback')

    if (errorHtml) {
        errorHtml.textContent = ''
    }

    element.classList.remove('is-invalid')
    element.classList.add('is-valid')
}

function validation(element) {
    let errorCounter = 0
    let formHtml = element.closest('form')
    let buttonSubmitHtml = element.closest('form').querySelector('[type="submit"]')
    let value = element.inputmask ? element.inputmask.unmaskedvalue() : element.value

    if (
        errorCounter === 0 &&
        element.hasAttribute('required') &&
        ((element.dataset.validation !== 'checkbox' &&
            element.dataset.validation !== 'select' &&
            validator.isEmpty(value)) ||
            (element.dataset.validation === 'checkbox' && !element.checked) ||
            (element.dataset.validation === 'select' && validator.isEmpty(element.options[element.selectedIndex].text)))
    ) {
        setInvalid(element, element.dataset.errorRequired)
        errorCounter++
    }

    if (
        errorCounter === 0 &&
        element.hasAttribute('size') &&
        !validator.isLength(value, { min: element.getAttribute('size'), max: element.getAttribute('size') })
    ) {
        setInvalid(element, element.dataset.errorSize)
        errorCounter++
    }

    if (
        errorCounter === 0 &&
        element.hasAttribute('minlength') &&
        !validator.isLength(value, { min: element.getAttribute('minlength') })
    ) {
        setInvalid(element, element.dataset.errorMinLength)
        errorCounter++
    }

    if (
        errorCounter === 0 &&
        element.hasAttribute('maxlength') &&
        !validator.isLength(value, { max: element.getAttribute('maxlength') })
    ) {
        setInvalid(element, element.dataset.errorMaxLength)
        errorCounter++
    }

    if (
        errorCounter === 0 &&
        element.hasAttribute('min') &&
        parseFloat(value) < parseFloat(element.getAttribute('min'))
    ) {
        setInvalid(element, element.dataset.errorMin)
        errorCounter++
    }

    if (
        errorCounter === 0 &&
        element.hasAttribute('max') &&
        parseFloat(value) > parseFloat(element.getAttribute('max'))
    ) {
        setInvalid(element, element.dataset.errorMax)
        errorCounter++
    }

    if (errorCounter === 0 && element.dataset.validation === 'email' && !validator.isEmail(value)) {
        setInvalid(element, element.dataset.errorWrong)
        errorCounter++
    }

    if (
        errorCounter === 0 &&
        element.dataset.validation === 'phone' &&
        !value.replace(/[() \-]/g, '').match(phoneRegex) // TODO: додати з бібліотеки
    ) {
        setInvalid(element, element.dataset.errorWrong)
        errorCounter++
    }

    if (
        errorCounter === 0 &&
        element.dataset.validation === 'fix-phone' &&
        !value.replace(/[() \-]/g, '').match(fixPhoneRegex) // TODO: додати з бібліотеки
    ) {
        setInvalid(element, element.dataset.errorWrong)
        errorCounter++
    }

    if (
        errorCounter === 0 &&
        element.dataset.validation === 'mobile-phone' &&
        !value.replace(/[() \-]/g, '').match(mobilePhoneRegex) // TODO: додати з бібліотеки
    ) {
        setInvalid(element, element.dataset.errorWrong)
        errorCounter++
    }

    if (errorCounter === 0 && element.dataset.validation === 'tin' && !isTaxID(value)) {
        setInvalid(element, element.dataset.errorWrong)
        errorCounter++
    }

    if (errorCounter === 0 && element.dataset.validation === 'currency' && !validator.isCurrency(value, {symbol: '', thousands_separator: '',  digits_after_decimal: [1, 2]})) {
        setInvalid(element, element.dataset.errorWrong)
        errorCounter++
    }

    if (errorCounter === 0 && element.dataset.validation.endsWith('_confirmation')) {
        let name = element.dataset.validation.replace('_confirmation', '')

        let confirmation = document.querySelector(`[data-validation="${name}"]`)

        if (value !== confirmation.value) {
            setInvalid(element, element.dataset.errorConfirmation)
            errorCounter++
        }
    }

    if (errorCounter === 0) {
        setValid(element)
    }

    if (!formHtml.classList.contains('needs-validation')) {
        return
    }

    if (formHtml.checkValidity() && errorCounter === 0) {
        buttonSubmitHtml.classList.remove('disabled')
        buttonSubmitHtml.removeAttribute('disabled')
    } else {
        if (!buttonSubmitHtml.classList.contains('disabled')) {
            buttonSubmitHtml.classList.add('disabled')
        }
        if (!buttonSubmitHtml.hasAttribute('disabled')) {
            buttonSubmitHtml.setAttribute('disabled', 'true')
        }
    }
}

function prepareDependencyField(id = null) {
    let fields = id ? document.querySelectorAll(`[data-dep-id="${id}"]`) : document.querySelectorAll('[data-dep-id]')

    fields.forEach((element) => {
        let field = document.querySelector(`[data-field-id="${element.dataset.depId}"]`)
        let wrapper = element.closest('[class^="col-"]')

        if (element.dataset.depVal.split(',').includes(field.value)) {
            wrapper.classList.remove('d-none')

            if (!element.classList.contains('js-disabled')) {
                element.removeAttribute('disabled')
            }

            if (wrapper.classList.contains('js-required-field')) {
                element.setAttribute('required', '')
            }
        } else {
            wrapper.classList.add('d-none')
            element.setAttribute('disabled', '')
            element.removeAttribute('required')
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    prepareDependencyField()

    // Loop over them and prevent submission
    document.querySelectorAll('.needs-validation').forEach((form) => {
        form.addEventListener(
            'submit',
            (event) => {
                if (!form.checkValidity()) {
                    event.preventDefault()
                    event.stopPropagation()

                    form.querySelectorAll('[data-validation]').forEach((element) => validation(element))
                }

                form.classList.add('was-validated')
            },
            false,
        )
    })

    document.querySelectorAll('[data-validation]').forEach((element) => {
        if (element.datepicker) {
            element.addEventListener('hide', () => validation(element))
        } else if (element.type === 'checkbox') {
            element.addEventListener('change', () => validation(element))
        } else if (element.type === 'radio') {
            element.addEventListener('click', () => validation(element))
        } else {
            element.addEventListener('focusout', () => validation(element))
        }
    })

    document.querySelectorAll('[data-field-id]').forEach((element) => {
        element.addEventListener('change', () => prepareDependencyField(element.dataset.fieldId))
    })
})

$(document).ready(function () {
    // if ($('.js-select').length) {
    //     $('.js-select').select2();
    // }
    $(document).on('click', '.js_validate button[type=submit], .js_validate input[type=submit]', function () {
        // var valid = validate($(this).parents(".js_validate"));
        // if (valid == false) {
        //     document.querySelector('.error').scrollIntoView({
        //         behavior: 'smooth',
        //         block: 'center',
        //     });
        //     return false;
        // }
        $(this)
            .parents('.js_validate')
            .on('submit', function () {
                var jsDisable = $(this).find('.js-disable')
                var jsLoading = $(this).find('.js-loading')
                jsDisable.attr('disabled', true)
                jsLoading.addClass('loading')

                setTimeout(function () {
                    jsDisable.removeAttr('disabled')
                    jsLoading.removeClass('loading')
                }, 30000)

                return true
            })
    })
    if ($('.js-mask-num-card').length) {
        $('.js-mask-num-card').mask('9999')
    }
    if ($('.js-mask-сvv').length) {
        $('.js-mask-сvv').mask('999')
    }

    var clientFiles = $('.client-files')
    if (clientFiles.length) {
        $.ajax({
            url: clientFiles.attr('data-url'),
            method: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    for (var i in data.files) {
                        $('#client-files-' + i).html(data.files[i].join(''))
                    }
                } else {
                    // $('input[type="file"]').attr('required', true);
                }
            },
            error: function (error) {},
        })
    }
})

/* -------------------------------------------------------------------------
    begin Validation
    * ------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-submit').forEach((element) => {
        element.closest('form').onsubmit = () => {
            disableSubmitButton(element)
            setTimeout(function () {
                enableSubmitButton(element)
            }, 3000)
        }
    })

    // Start init Select field
    document.querySelectorAll('.js-select').forEach((element) => {
        if (element.dataset.placeholderText) {
            const placeholderOption = document.createElement('option')
            if (!element.options[element.selectedIndex].hasAttribute('selected'))
                placeholderOption.setAttribute('selected', '')
            placeholderOption.setAttribute('data-placeholder', 'true')
            element.insertBefore(placeholderOption, element.firstChild)
        }
    })
    document.querySelectorAll('.js-select').forEach((element) => {
        new SlimSelect({
            select: element,
            settings: {
                placeholderText: element.dataset.placeholderText ? element.dataset.placeholderText : '',
                showSearch: element.dataset.showSearch === 'true',
                searchText: element.dataset.searchText ? element.dataset.searchText : '',
                searchPlaceholder: element.dataset.searchPlaceholder ? element.dataset.searchPlaceholder : '',
            },
            events: {
                afterChange: () => validation(element),
            },
        })
    })
    // End init Select field

    // Start init Datepicker field
    Object.assign(Datepicker.locales, uk, ru)
    document.querySelectorAll('[name="date_of_birth"]').forEach((element) => {
        let date = new Date()

        new Datepicker(element, {
            autohide: true,
            buttonClass: 'btn',
            format: 'dd.mm.yyyy',
            language: document.querySelector('html').lang,
            maxDate: new Date(date.getFullYear() - 18, date.getMonth(), date.getDate()),
            minDate: new Date(date.getFullYear() - 110, date.getMonth(), date.getDate()),
            startView: 2,
        })
    })
    document.querySelectorAll('.js-datepicker').forEach((element) => {
        new Datepicker(element, {
            autohide: true,
            buttonClass: 'btn',
            format: 'dd.mm.yyyy',
            language: document.querySelector('html').lang,
        })
    })
    // End init Datepicker field

    // TODO
    // document.querySelectorAll('[data-validation]').forEach(element => {
    //     element.onchange = () => {
    //         let value
    //
    //         switch (element.dataset.validation) {
    //             case 'phone':
    //                 value = element.inputmask ? element.inputmask.unmaskedvalue() : element.value
    //                 validator.isMobilePhone(`+38${value}`, 'uk-UA')
    //                 break
    //             case 'phone-mobile':
    //                 value = element.inputmask ? element.inputmask.unmaskedvalue() : element.value
    //                 break
    //             case 'phone-fix':
    //                 value = element.inputmask ? element.inputmask.unmaskedvalue() : element.value
    //                 break
    //         }
    //     }
    // })
})

$(document).ready(function () {
    setTimeout(function () {
        $(document).on('change', '.js_validate *[required]', function () {
            $(this).each(function () {
                var valid = validate($(document).find($(this)))
                if (valid == false) {
                    return false
                } else {
                }
            })
        })
    }, 1)

    $('.js_validate .btn[type="submit"], .js_validate .js-validate-btn').on('click', function (event) {
        let valid = validate($(document).find($(this).parents('.js_validate')))
        if (!valid) {
            document.querySelector('.error').scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            })
            return false
        }
    })
})

function formatValidate(inputFile) {
    function showMsg(massage) {
        $($($($(inputFile)[0]).siblings('.form-error'))[0]).text(massage)
        $(inputFile[0]).closest('.form__item__file').addClass('error')
        return false
    }

    var format = ['.pdf', '.txt', '.doc', '.docx', '.rtf', '.odt']
    if (inputFile[0].files.length != 1) {
        showMsg($($(inputFile)[0]).attr('data-error-existence'))
        return false
    } else {
        var file = inputFile[0].files
        var fileName = file[0].name
        if (file[0].size / 1024 / 1024 < 5) {
            for (var i = 0; i < format.length; i++) {
                if (-1 !== fileName.indexOf(format[i])) {
                    $($(inputFile)[0]).closest('.form__item__file').removeClass('error')
                    $($(inputFile)[0]).closest('.form__item__file').addClass('pass')
                    $($(inputFile)[0]).siblings('.form-error').text('')
                    return true
                } else {
                    showMsg($($(inputFile)[0]).attr('data-error-type'))
                }
            }
        } else {
            showMsg($($(inputFile)[0]).attr('data-error-size'))
        }
    }
}

function validate(form) {
    var error_class = 'error'
    var norma_class = 'pass'
    var item = form.find('[required]')
    var e = 0
    var reg = undefined
    var pass = $('.js-password').val()
    var pass1 = $('.js-repeat-password').val()
    var passold = $('.js-old-password').val()
    var email = false
    var password = false
    var password_1 = false
    var password_old = false
    var password_one = false
    var phone = false
    var undef = false
    var date = false
    var number = false
    var sum = false
    var arr = []

    function mark(object, expression, minSign, maxSign) {
        if (expression) {
            object.closest('.js-form-element').addClass(error_class).removeClass(norma_class)
            if (email) {
                if (object.val().length > 0) {
                    if (object.val().length < 6) {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-min'))
                    } else if (object.val().length > 37) {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-max'))
                    } else {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-wrong'))
                    }
                } else {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-empty'))
                }
            }
            if (password_old) {
                if (object.val().length > 0) {
                    if (object.val().length < 6) {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-min'))
                    } else if (object.val().length > 20) {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-max'))
                    } else {
                        if (object.val() == pass || object.val() == pass1) {
                            object
                                .closest('.js-form-element')
                                .find('.form-error')
                                .text(object.attr('data-error-wrong-old'))
                        } else {
                            object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-wrong'))
                        }
                    }
                } else {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-empty'))
                }
            }
            if (password) {
                if (object.val().length > 0) {
                    if (object.val().length < 6) {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-min'))
                    } else if (object.val().length > 20) {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-max'))
                    } else {
                        if (object.val() == passold) {
                            object
                                .closest('.js-form-element')
                                .find('.form-error')
                                .text(object.attr('data-error-wrong-old'))
                            // } else if (object.val()!==pass1) {
                            //     object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong-new"));
                        } else if (object.val() !== pass1) {
                            object
                                .closest('.js-form-element')
                                .find('.form-error')
                                .text(object.attr('data-error-wrong-new'))
                        } else {
                            object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-wrong'))
                        }
                    }
                } else {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-empty'))
                }
            }
            if (password_one) {
                if (object.val().length > 0) {
                    if (object.val().length < 6) {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-min'))
                    } else if (object.val().length > 20) {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-max'))
                    }
                } else {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-empty'))
                }
            }
            if (password_1) {
                if (object.val().length > 0) {
                    if (object.val().length < 6) {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-min'))
                    } else if (object.val().length > 20) {
                        object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-max'))
                    } else {
                        if (object.val() == passold) {
                            object
                                .closest('.js-form-element')
                                .find('.form-error')
                                .text(object.attr('data-error-wrong-old'))
                        } else if (object.val() !== pass) {
                            object
                                .closest('.js-form-element')
                                .find('.form-error')
                                .text(object.attr('data-error-wrong-new'))
                        } else {
                            object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-wrong'))
                        }
                    }
                } else {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-empty'))
                }
            }
            if (phone) {
                if (object.val().length < 1) {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-empty'))
                }
            }
            if (date) {
                if (object.val().length != 4) {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-empty'))
                } else {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-wrong'))
                }
            }
            if (number) {
                if (object.val().length < 4 || object.val().length > 100) {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-empty'))
                } else {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-wrong'))
                }
            }
            if (sum) {
                if (minSign && parseFloat(object.val()) < parseFloat(minSign)) {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-greater'))
                } else if (maxSign && parseFloat(object.val()) > parseFloat(maxSign)) {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-less'))
                }
            }
            if (undef) {
                if (object.val().length > 0) {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-wrong'))
                } else {
                    object.closest('.js-form-element').find('.form-error').text(object.attr('data-error-empty'))
                }
            }
            e++
        } else {
            if ($(object[0]).hasClass('select')) {
                if ($(object[0]).prop('selectedIndex') != 0) {
                    object.closest('.js-form-element').addClass(norma_class).removeClass(error_class)
                    e = 0
                } else {
                    object.closest('.js-form-element').addClass(error_class).removeClass(norma_class)
                    e = 0
                }
            } else {
                object.closest('.js-form-element').addClass(norma_class).removeClass(error_class)
                e = 0
            }
        }
        arr.push(expression)
    }

    if (form.hasClass('js_validate')) {
        var field = form.find('[required]'),
            // select = form.find('.js-validate-select'),
            inputContainer = form.closest('.js-validate-select'),
            select = inputContainer.find('select option'),
            radio = form.find('.js_valid_radio'),
            file = form.find('.form__item__file'),
            checkbox = form.find('.js-validate-checkbox')
        field.each(function () {
            var dataValidate = $(this).attr('data-validate')
            caseDataValidate(dataValidate, $(this))
        })
        select.each(function () {
            validSelect(form.find('.js-validate-select').find('select option'))
        })
        radio.each(function () {
            validRadio($(this).find('input[type="radio"]'))
        })
        checkbox.each(function () {
            validCheckbox($(this).find('input[type="checkbox"]'))
        })
        file.each(function () {
            validFile($(this).find('input[type="file"]'))
        })
    } else {
        var dataValidate = form.attr('data-validate'),
            inputContainer = form.closest('.js-form-element'),
            field = form,
            select = inputContainer.find('select option'),
            radio = inputContainer.find('input[type="radio"]'),
            file = inputContainer.find('input[type="file"]'),
            checkbox = inputContainer.find('input[type="checkbox"]')
        if (inputContainer.hasClass('js-validate-select')) {
            validSelect(select)
        } else if (inputContainer.hasClass('js_valid_radio')) {
            validRadio(radio)
        } else if (inputContainer.hasClass('js-validate-checkbox')) {
            validCheckbox(checkbox)
        } else if (inputContainer.hasClass('form__item__file')) {
            validFile(file)
        } else {
            caseDataValidate(dataValidate, field)
        }
    }

    function caseDataValidate(dataValidate, fieldIn) {
        var minSign = fieldIn.attr('data-minsign')
        var maxSign = fieldIn.attr('data-maxsign')
        switch (dataValidate) {
            case 'text':
                reg = new RegExp('^[/\'"?!,.А-Яа-яёЁЇїІіЄєҐґa-zA-Z_0-9 -]{' + minSign + ',' + maxSign + '}$')

                undef = true
                mark(fieldIn, !reg.test($.trim(fieldIn.val())), minSign, maxSign)
                undef = false
                break
            case 'date':
                // reg = /^\d{2,10}[,.]?\d{2,10}[,.]?\d{2,10}$/;
                date = true
                // mark(fieldIn, !reg.test($.trim(fieldIn.val())));
                mark(fieldIn, $.trim(fieldIn.val()).length === 0)
                date = false
                break
            case 'number':
                //reg = /^\d+$/;
                reg = new RegExp('^[0-9]{' + minSign + ',' + maxSign + '}$')
                number = true
                mark(fieldIn, !reg.test($.trim(fieldIn.val())))
                number = false
                break
            case 'sum':
                //reg = /^\d+$/;
                // reg = new RegExp('^[0-9]{'+minSign+', }$');
                reg = parseFloat(minSign) > parseFloat(fieldIn.val()) || parseFloat(fieldIn.val()) > parseFloat(maxSign)
                sum = true
                // mark(fieldIn, !reg.test($.trim(fieldIn.val())), minSign);
                mark(fieldIn, reg, minSign, maxSign)
                sum = false
                break
            case 'email':
                reg = /^([A-Za-z0-9_\-\.]{1,15})+\@([A-Za-z0-9_\-\.]{1,10})+\.([A-Za-z]{2,10})$/
                email = true
                if ($.trim(fieldIn.val()).length > 37) {
                    mark(fieldIn, true)
                } else {
                    mark(fieldIn, !reg.test($.trim(fieldIn.val())))
                }
                email = false
                break
            case 'phone':
                phone = true
                // reg = /[0-9-()+]{17}$/;
                reg = /[0-9- ()+]{10}$/
                mark(fieldIn, !reg.test($.trim(fieldIn.val())))
                phone = false
                break
            case 'passold':
                password_old = true
                reg = /^[a-zA-Z0-9!#@_\-|]{6,20}$/
                mark(fieldIn, passold == pass || !reg.test($.trim(fieldIn.val())) || passold == pass1)
                password_old = false
                break
            case 'pass':
                password = true
                reg = /^[a-zA-Z0-9!#@_\-|]{6,20}$/
                //mark(fieldIn, (pass1 !== pass||!reg.test($.trim(fieldIn.val()))||passold==pass));
                mark(fieldIn, (pass1 !== pass && pass1 !== '') || !reg.test($.trim(fieldIn.val())) || passold == pass)
                password = false
                break
            case 'passone':
                password_one = true
                reg = /^[a-zA-Z0-9!#@_\-|]{6,20}$/
                mark(fieldIn, !reg.test($.trim(fieldIn.val())))
                password_one = false
                break
            case 'pass1':
                password_1 = true
                reg = /^[a-zA-Z0-9!#@_\-|]{6,20}$/
                mark(fieldIn, pass1 !== pass || !reg.test($.trim(fieldIn.val())) || passold == pass1)
                password_1 = false
                break
            case 'file':
                formatValidate(fieldIn)
                break
            case 'select2':
                if (fieldIn.val()) {
                    mark(fieldIn, false)
                    break
                } else {
                    mark(fieldIn, true)
                    break
                }

            // mark($(this), $.trim($(this).val()).length === 0);
            // break;
            default:
                undef = true
                reg = new RegExp(fieldIn.attr('data-validate'), 'g')
                mark(fieldIn, !reg.test($.trim(fieldIn.val())))
                undef = false
                break
        }
    }

    // js-validate-select
    function validSelect(inp) {
        var rezalt = 0
        for (var i = 1; i < inp.length; i++) {
            if ($(inp[i]).is('selected') === true || $(inp[i]).prop('selected') === true) {
                rezalt = 1
                break
            } else {
                rezalt = 0
            }
        }
        if (rezalt === 0) {
            inp.closest('.js-form-element').addClass(error_class).removeClass(norma_class)
            e = 1
        } else {
            inp.closest('.js-form-element').addClass(norma_class).removeClass(error_class)
            inp.closest('.js-form-element').addClass(norma_class).removeClass(error_class)
        }
    }

    // js_valid_radio
    function validRadio(inp) {
        var rezalt = 0
        for (var i = 0; i < inp.length; i++) {
            if ($(inp[i]).is(':checked') === true) {
                rezalt = 1
                break
            } else {
                rezalt = 0
            }
        }
        if (rezalt === 0) {
            inp.closest('.js-form-element').addClass(error_class).removeClass(norma_class)
            e = 1
        } else {
            inp.closest('.js-form-element').addClass(norma_class).removeClass(error_class)
        }
    }
    // js_valid_checkbox
    function validCheckbox(inp) {
        var rezalt = 0
        for (var i = 0; i < inp.length; i++) {
            if ($(inp[i]).prop('required')) {
                if ($(inp[i]).is(':checked') === true) {
                    rezalt = 1
                    break
                } else {
                    rezalt = 0
                }
            } else {
                rezalt = 1
                break
            }
        }
        if (rezalt === 0) {
            inp.closest('.js-form-element').addClass(error_class).removeClass(norma_class)
            e = 1
        } else {
            inp.closest('.js-form-element').addClass(norma_class).removeClass(error_class)
        }
    }

    // js_valid_file
    function validFile(inp) {
        var rezalt = 0
        for (var i = 0; i < inp.length; i++) {
            if (formatValidate(inp) == true) {
                rezalt = 1
                break
            } else {
                rezalt = 0
            }
        }
        if (rezalt === 0) {
            inp.closest('.js-form-element').addClass(error_class).removeClass(norma_class)
            e = 1
        } else {
            inp.closest('.js-form-element').addClass(norma_class).removeClass(error_class)
        }
    }
    // js_valid_rating
    //     form.find('.js-rating').each(function (indx, rating) {
    //         var i = 0;
    //         $(rating).find(".star").each(function (indx, star) {
    //             if($(star).hasClass("active")) {
    //                 i++;
    //             } else {
    //             }
    //         });
    //         if (i>0) {
    //             $(this).addClass(norma_class).removeClass(error_class);
    //         } else {
    //             $(rating).addClass(error_class).removeClass(norma_class);
    //             e = 1;
    //         }
    //     });

    if ($.inArray(true, arr) === -1 && e === 0) {
        return true
    } else {
        return false
    }
}

$('.js-form-element .delete').click(function () {
    var error_class = 'error'
    var inp = $(this).siblings('input')
    var label = $(this).siblings('label')
    inp.val('')
    inp.closest('.js-form-element').removeClass(error_class)
    inp.closest('.js-form-element').removeClass('filled')
    if (inp[0].hasAttribute('data-error-existence')) {
        label.text(inp.attr('data-error-existence'))
    } else {
    }
})

/* -------------------------------------------------------------------------
 end Validation
 * ------------------------------------------------------------------------- */
